import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { UserPlanDevDTO } from '../models/UserPlanDevDTO.model';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private httpService: HttpService) { }

  calculateProrationStart(usrPlanDev: UserPlanDevDTO) {
    return this.httpService.calculateProrationStart(usrPlanDev).pipe(
      tap((data) => {
      })
    );
  }

  calculateProrationEnd(usrPlanDev: UserPlanDevDTO) {
    return this.httpService.calculateProrationEnd(usrPlanDev).pipe(
      tap((data) => {
      })
    );
  }
}
